import React from 'react';
import cls from '@utils/css-select';
import { I18nMessage } from '@fe/i18n';

import styles from './styles.scss';
import Section from 'components/section';
const cx = cls(styles);

const Message = I18nMessage('landing');
const ItemMap = [
	{
		icon: 'https://web-data.zmlearn.com/image/c3mSGtybZkXaDMFosiV5Wh/24%402x.png',
		title: 'STEP 1',
		desc: 'Leave your info.',
	},
	{
		icon: 'https://web-data.zmlearn.com/image/f7zXBZbLn3m3fRejQszARf/25%402x.png',
		title: 'STEP 2',
		desc: 'Our consultant will help you schedule a class with a suitable tutor.',
	},
	{
		icon: 'https://web-data.zmlearn.com/image/oJbFE64xCtomxJV7LJHntu/26%402x.png',
		title: 'STEP 3',
		desc: 'Download Zoom and enjoy the class! ',
	},
];

/**
 * 上课步骤
 */
export default function StepBox() {
	return (
		<div className={cx('step-box')}>
			<Section className={cx('inner')}>
				<h3 className={cx('block-title', 'black')}>
					Starting from <Message id="price"></Message>, private 1-on-1 <br />
					class with excellent tutors!
				</h3>
				<div className={cx('content')}>
					<div className={cx('demo')}>
						<img loading="lazy" src="https://web-data.zmlearn.com/image/hZynJjuJbz2qrFFADLtRaQ/23%402x.png" alt="teaching" />
					</div>
					<div className={cx('steps')}>
						<h5>Steps to schedule and take a class:</h5>
						{ItemMap.map((item, idx) => {
							return (
								<div className={cx('step')} key={idx}>
									<img loading="lazy" src={item.icon} className={cx('icon')} alt={item.title} />
									<div className={cx('desc')}>
										<span className={cx('key')}>{item.title}</span>
										<span className={cx('txt')}>{item.desc}</span>
									</div>
								</div>
							);
						})}
					</div>
				</div>
			</Section>
		</div>
	);
}
